import React from 'react';
import { bool, node, number, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './MainPanelHeader.module.css';
import { useLocation, useParams } from 'react-router-dom';
import { parse } from '../../../util/urlHelpers';
import { filters } from '../../../config/marketplace-custom-config';
import find from 'lodash/find';

const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    resultsCount,
    searchInProgress,
    noResultsInfo,
    isKeywordSearch,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const { search } = useLocation();
  const { address, pub_category, origin } = parse(search);
  const options = find(filters, { id: 'category' })?.config?.options;
  const category = find(options, { key: pub_category })?.label;
  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <div className={css.searchResultSummary}>
          <span className={css.resultsFound}>
            {searchInProgress ? (
              <FormattedMessage id="MainPanelHeader.loadingResults" />
            ) : (
              <>
                <h1 className={css.searchHeader}>
                  <FormattedMessage id="MainPanelHeader.searchHeader" />
                </h1>
                <span>{resultsCount} </span>
                {pub_category && <span className={css.resultCategory}>{category} </span>}
                <span>result(s) (ordered by </span>
                {address ? (
                  <>
                    <span> proximity to </span>
                    <span className={css.resultAddress}>{address}</span>
                  </>
                ) : (
                  <span>{origin ? 'current location' : 'newest'}</span>
                )}
                <span>)</span>
              </>
            )}
          </span>
        </div>
        {isKeywordSearch ? (
          <div className={css.sortyByWrapper}>
            <span className={css.sortyBy}>
              <FormattedMessage id="MainPanelHeader.sortBy" />
            </span>
            {sortByComponent}
          </div>
        ) : null}
      </div>

      {children}

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

MainPanelHeader.defaultProps = {
  rootClassName: null,
  className: null,
  resultsCount: null,
  searchInProgress: false,
  sortByComponent: null,
};

MainPanelHeader.propTypes = {
  rootClassName: string,
  className: string,
  listingsAreLoaded: bool.isRequired,
  resultsCount: number,
  searchInProgress: bool,
  sortByComponent: node,
  isKeywordSearch: bool.isRequired,
};

export default MainPanelHeader;
